export default __webpack_public_path__ + "src/assets/receive.13b4c05c3e53bb6f3dc07e107b54a88d.svg";